import { ContentNodeUtils } from '../../ContentNode/ContentNode.utils';
import { createRuntimeOperationType } from './common';
export const queryVariableReferenceOperationType = createRuntimeOperationType({
    kind: 'QUERY_VARIABLE_REFERENCE',
    dependencies: () => [],
    run: (locator, context) => {
        const currentQueryNode = context.currentQueryNode;
        if (!currentQueryNode) {
            throw new Error('QUERY_VARIABLE_REFERENCE requires currentQueryNode in context');
        }
        const variableContentNodes = currentQueryNode.queryVariableContentNodes;
        if (!variableContentNodes || variableContentNodes.length === 0) {
            return null;
        }
        try {
            if (locator.length > 0 && locator[0][0] === 'key') {
                const variableKey = locator[0][1];
                const variableContentNode = variableContentNodes.find((node) => node.kind === 'INPUT_VALUE' && node.key === variableKey);
                if (variableContentNode) {
                    if (locator.length > 1) {
                        const remainingLocator = locator.slice(1);
                        const foundNode = ContentNodeUtils.findContentNode(remainingLocator)(variableContentNode);
                        return foundNode?.data ?? null;
                    }
                    return variableContentNode.data ?? null;
                }
            }
            return null;
        }
        catch (error) {
            console.error('Error finding query variable:', error);
            return null;
        }
    },
});
//# sourceMappingURL=query-variable-reference.js.map